// assistantMarkdownComponents.jsx — A5 shared constrained react-markdown component map.
//
// Extracted from AssistantMarkdown.jsx so BOTH the settled-assistant renderer
// (AssistantMarkdown.jsx) and the streaming live-lane renderer (StreamingMarkdown.jsx)
// feed react-markdown the SAME known-safe subset. Single source of truth = one place to
// audit the multi-tenant safety boundary.
//
// SAFETY (multi-tenant; model-authored text is untrusted):
//   - Component map is CONSTRAINED to a known-safe subset (p, strong, em, code/pre, ul/ol/li, a,
//     and GFM tables). No headings/images/html.
//   - REMARK_PLUGINS is the one plugin list both renderers share: remark-gfm only, which is what
//     makes `| a | b |` pipe tables parse at all (core markdown has no tables — without it the
//     DNS-records table the agent sends printed as raw pipes). It is a PARSER plugin; it adds no
//     raw-HTML path. NO rehype-raw, ever.
//   - Links open in a new tab with rel="noopener noreferrer" (no reverse-tabnabbing / referrer leak).
//   - This file carries JSX, so it is a `.jsx` and is NEVER imported by a `*.test.mjs`
//     (no webpack/JSX transform under `node --test`). It is covered by source-guards only.
//
// Classed under .st-md so SCSS (agent_shell.scss) owns layout — no inline JS style
// (webpacker hash gotcha: layout lives in SCSS, not bundled JS).

import React from "react"
import remarkGfm from "remark-gfm"

export const REMARK_PLUGINS = [remarkGfm]

export const COMPONENTS = {
  p:      ({ node, ...props }) => <p className="st-md__p" {...props} />,
  strong: ({ node, ...props }) => <strong {...props} />,
  em:     ({ node, ...props }) => <em {...props} />,
  ul:     ({ node, ...props }) => <ul className="st-md__ul" {...props} />,
  ol:     ({ node, ...props }) => <ol className="st-md__ol" {...props} />,
  li:     ({ node, ...props }) => <li className="st-md__li" {...props} />,
  code:   ({ node, ...props }) => <code className="st-md__code" {...props} />,
  pre:    ({ node, ...props }) => <pre className="st-md__pre" {...props} />,
  a:      ({ node, ...props }) => (
    <a className="st-md__a" target="_blank" rel="noopener noreferrer" {...props} />
  ),
  // Tables sit in a scroll wrapper so a wide one scrolls sideways instead of widening the bubble.
  table:  ({ node, ...props }) => (
    <div className="st-md__table-wrap"><table className="st-md__table" {...props} /></div>
  ),
  th:     ({ node, ...props }) => <th className="st-md__th" {...props} />,
  td:     ({ node, ...props }) => <td className="st-md__td" {...props} />,
}

export default COMPONENTS
